var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', [_c('b-col', [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'Home'
        });
      }
    }
  }, [_vm._v(" 首頁 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(" 參數設定 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(" CYBERBIZ 標籤批量調整（逐筆同步） ")])], 1)], 1)])], 1), _c('b-row', [_c('b-col', [_c('b-card', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('div', [_c('h4', {
    staticClass: "font-weight-bold mb-2"
  }, [_vm._v("CYBERBIZ 標籤批量調整（逐筆同步）")]), _c('p', {
    staticClass: "mb-2 text-muted"
  }, [_vm._v(" 上傳 Excel 後，系統會逐筆同步會員標籤到 CYBERBIZ。 ")])])]), _c('div', {
    staticClass: "import-form"
  }, [_c('b-form-group', {
    attrs: {
      "label-for": "merchant-select"
    }
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "merchant-select"
    }
  }, [_vm._v("品牌")]), _c('b-form-select', {
    attrs: {
      "id": "merchant-select",
      "options": _vm.merchantOptions,
      "disabled": _vm.isFetchingMerchants
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null,
            "disabled": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.isFetchingMerchants ? '載入中...' : '請選擇品牌') + " ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.selectedMerchantId,
      callback: function callback($$v) {
        _vm.selectedMerchantId = $$v;
      },
      expression: "selectedMerchantId"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-for": "tag-file"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-1"
  }, [_c('label', {
    staticClass: "field-label mb-0",
    attrs: {
      "for": "tag-file"
    }
  }, [_vm._v("Excel 檔案")])]), _c('b-form-file', {
    attrs: {
      "id": "tag-file",
      "accept": ".xlsx,.xls",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽",
      "plain": ""
    },
    model: {
      value: _vm.selectedFile,
      callback: function callback($$v) {
        _vm.selectedFile = $$v;
      },
      expression: "selectedFile"
    }
  }), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v(" 格式：第 1 欄為 CYBERBIZ 會員編號，第 2 欄為 CYBERBIZ 標籤名稱。支援 xlsx / xls，可包含表頭。 ")]), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v(" 標籤可填多個，請用半形逗號分隔（例如：`北部,南部,中部`）。 ")]), _c('small', {
    staticClass: "form-text text-danger"
  }, [_vm._v(" 請勿填入 內部系統會員編號 或 內部系統會員等級名稱。 ")]), _c('b-button', {
    staticClass: "p-0",
    attrs: {
      "variant": "link",
      "size": "sm"
    },
    on: {
      "click": function click($event) {
        return _vm.getSampleExcelFile(null, '/excel/cyberbiz_tag_list_change.xlsx');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text mr-1",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 下載範例檔案 ")])], 1)], 1), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": !_vm.canSubmit
    },
    on: {
      "click": _vm.handlePreviewSubmit
    }
  }, [_vm.isSubmitting ? _c('b-spinner', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }) : _c('i', {
    staticClass: "mdi mdi-sync mr-1",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.isSubmitting ? '同步中...' : '開始同步') + " ")], 1)], 1)]), _vm.showResult ? _c('b-card', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3"
  }, [_c('div', [_c('h5', {
    staticClass: "font-weight-bold mb-1"
  }, [_vm._v("同步結果")]), _c('p', {
    staticClass: "mb-0 text-muted"
  }, [_vm._v("以下為後端回傳的同步統計與錯誤列。")])])]), _c('b-row', {
    staticClass: "mb-3"
  }, _vm._l(_vm.summaryItems, function (item) {
    return _c('b-col', {
      key: item.label,
      staticClass: "mb-2",
      attrs: {
        "cols": "12",
        "md": "4"
      }
    }, [_c('div', {
      class: ['summary-item', "summary-item-".concat(item.variant)]
    }, [_c('div', {
      staticClass: "summary-label"
    }, [_vm._v(_vm._s(item.label))]), _c('div', {
      staticClass: "summary-value"
    }, [_vm._v(_vm._s(item.value))]), _c('div', {
      staticClass: "summary-description"
    }, [_vm._v(_vm._s(item.description))])])]);
  }), 1), _vm.errorRows.length > 0 ? _c('b-table', {
    attrs: {
      "responsive": "",
      "striped": "",
      "hover": "",
      "items": _vm.errorRows,
      "fields": _vm.errorFields
    },
    scopedSlots: _vm._u([{
      key: "cell(status)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.getStatusVariant(data.item.status)
          }
        }, [_vm._v(" " + _vm._s(_vm.getStatusText(data.item.status)) + " ")])];
      }
    }], null, false, 3421781107)
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }